
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Portfolio = lazy(() => import('../pages/portfolio/page'));
const News = lazy(() => import('../pages/news/page'));
const AipaiIndex = lazy(() => import('../pages/aipai-index/page'));
const PaiCapital = lazy(() => import('../pages/pai-capital/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/portfolio',
    element: <Portfolio />,
  },
  {
    path: '/news',
    element: <News />,
  },
  {
    path: '/aipai-index',
    element: <AipaiIndex />,
  },
  {
    path: '/pai-capital',
    element: <PaiCapital />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
